import React, { useContext, useReducer } from "react";

const helperContext = React.createContext();

const initialState = {
  testTempModal: false,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "SET_TEST_TEMP_MODAL": {
      return {
        ...state,
        testTempModal: action.payload,
      };
    }

    default:
      return state;
  }
};

export function HelperProvider(props) {
  const [helperC, dispatchHelper] = useReducer(reducer, initialState);
  return (
    <helperContext.Provider value={{ helperC, dispatchHelper }} {...props} />
  );
}

export function HelperContext() {
  const context = useContext(helperContext);
  if (!context) {
    throw new Error(" Please use the context inside parent scope");
  }
  return context;
}
